module.exports = __webpack_public_path__ + "static/media/fabi-laptop.b3e6904f.png";